export default "__VITE_ASSET__DZn51V6i__"